import React, { useEffect, useState, useContext } from "react";
import IhealContext from "../../Context/IhealContext.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartOutline } from "@fortawesome/free-regular-svg-icons";
import { useApolloClient } from "@apollo/client/react";
import { GET_SAVED_ITEMS } from "../../GraphqlService";
import { useQuery } from "@apollo/client/react";

const SaveHeart = props => {
	const iHeal = useContext(IhealContext);
	const { toggleSaved, itemId } = props;
	const [loading, setLoading] = useState(false);
	const client = useApolloClient();

	const savedQuery = useQuery(GET_SAVED_ITEMS, {
		variables: { userid: iHeal.userInfo.userid },
	});
	const savedQueryReady = !savedQuery.loading && !savedQuery.error;

	function saved() {
		return (
			savedQueryReady &&
			savedQuery.data.entries
				.flatMap(e => e.savedItem)
				.filter(e => e.id == itemId).length > 0
		);
	}

	return (
		<FontAwesomeIcon
			style={{ cursor: toggleSaved !== undefined ? "pointer" : "inherit" }}
			icon={loading ? faSpinner : saved() ? faHeart : faHeartOutline}
			spin={loading}
			onClick={() => {
				if (!loading && toggleSaved !== undefined) {
					setLoading(true);
					toggleSaved(saved()).then(() => {
						client.refetchQueries({ include: [GET_SAVED_ITEMS] }).then(() => {
							setLoading(false);
						});
					});
				}
			}}
		/>
	);
};

export default SaveHeart;
